module.exports = __webpack_public_path__ + "plus/img/132daa1c5e4e6687e6019bd3f298ecf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/deps/public/logo1.png
// module id = BBzK
// module chunks = 12